"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var cache_1 = __importDefault(require("@emotion/cache"));
var react_1 = require("@emotion/react");
var react_components_1 = require("@gamepark/react-components");
var react_2 = require("react");
var stylis_1 = require("stylis");
var RemoteGameProvider_1 = __importDefault(require("../api/Client/RemoteGameProvider"));
var LocalGameProvider_1 = __importDefault(require("../api/Local/LocalGameProvider"));
var DatadogLogsInitializer_1 = require("../datadog/DatadogLogsInitializer");
var webPReplace_1 = __importDefault(require("../util/webPReplace"));
var GameContext_1 = require("./GameContext");
var GameProviderProps_1 = require("./GameProviderProps");
var query = new URLSearchParams(window.location.search);
var gameId = query.get('game');
(0, DatadogLogsInitializer_1.initDatadogLogs)();
function GameProvider(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var RulesView = ((0, GameProviderProps_1.isGameViewProviderProps)(props) ? props.RulesView : props.Rules);
    var gameViewProps = __assign(__assign({}, props), { RulesView: RulesView });
    var webP = (0, react_components_1.useWebP)();
    var emotionCache = (0, react_2.useMemo)(function () { return (0, cache_1.default)({
        key: 'css', stylisPlugins: (webP ? [webPReplace_1.default, stylis_1.prefixer] : [stylis_1.prefixer])
    }); }, [webP]);
    return ((0, jsx_runtime_1.jsx)(GameContext_1.gameContext.Provider, __assign({ value: gameViewProps }, { children: (0, jsx_runtime_1.jsx)(react_1.CacheProvider, __assign({ value: emotionCache }, { children: gameId ?
                (0, jsx_runtime_1.jsx)(RemoteGameProvider_1.default, __assign({ gameId: gameId }, { children: children })) :
                (0, jsx_runtime_1.jsx)(LocalGameProvider_1.default, { children: children }) })) })));
}
exports.default = GameProvider;
